import React, { Fragment, useMemo } from 'react';
import {
  ListingCardPlaceholder,
  ListingCardPlaceholderResponsive,
} from 'router/subrouters/Dash/subrouters/Business/pages/Businesses/placeholder';

export default function useListingCardPlaceholder(numberOfCards = 10) {
  return useMemo(
    () =>
      Array(numberOfCards)
        .fill(1)
        .map((_, i) => (
          <Fragment key={i}>
            <ListingCardPlaceholderResponsive />
            <ListingCardPlaceholder />
          </Fragment>
        )),
    [numberOfCards],
  );
}
